module.exports = __webpack_public_path__ + "static/media/perth-traffic.fea59e56.png";